import { GitBranch } from "lucide-react";

/**
 * Chart type options per report type. Used by ChartTypeDropdown.
 * Insight: full set. Funnel: Funnel Steps, Line, Bar, Metric. Flow: Sankey vs top paths.
 */
/** Chart types that use a calendar time axis (show Hour/Day/Week/Month bucket control). */
export const INSIGHT_TIME_SERIES_CHART_IDS = ["line", "stacked-line", "column", "stacked-column"];

export function isInsightTimeSeriesChart(chartType) {
  return INSIGHT_TIME_SERIES_CHART_IDS.includes(chartType);
}

export const INSIGHT_CHART_TYPES = [
  { id: "line", label: "Line", iconName: "linechart" },
  { id: "stacked-line", label: "Stacked Line", iconName: "stacked_linechart" },
  { id: "column", label: "Column & Bar", iconName: "barchart" },
  { id: "stacked-column", label: "Stacked Column", iconName: "stacked_barchart" },
  { id: "bar", label: "Bar", iconName: "barchart" },
  { id: "stacked-bar", label: "Stacked Bar", iconName: "stacked_barchart" },
  { id: "pie", label: "Pie", iconName: "piechart" },
  { id: "table", label: "Table", iconName: "table" },
  { id: "metric", label: "Metric", iconName: "metric" },
];

export const FUNNEL_CHART_TYPES = [
  { id: "funnel-steps", label: "Funnel Steps", iconName: "funnel" },
  { id: "line", label: "Line", iconName: "linechart" },
  { id: "bar", label: "Bar", iconName: "barchart" },
  { id: "metric", label: "Metric", iconName: "metric" },
];

export const RETENTION_CHART_TYPES = [
  { id: "retention-curve", label: "Retention Curve", iconName: "linechart" },
  { id: "line", label: "Line", iconName: "linechart" },
  { id: "metric", label: "Metric", iconName: "metric" },
];

export const FLOW_CHART_TYPES = [
  { id: "flows", label: "Flows", iconName: "flows" },
  { id: "topPaths", label: "Top paths", icon: GitBranch },
];

/**
 * @param {"insight" | "funnel" | "retention" | "flow"} reportType
 * @param {{ funnelMeasuring?: string }} [opts]
 * @returns {Array<{ id: string, label: string, iconName?: string, icon?: React.ComponentType, disabled?: boolean }>}
 */
export function getChartTypesForReportType(reportType, opts = {}) {
  if (reportType === "funnel") {
    if (opts.funnelMeasuring === "time_to_convert") {
      return FUNNEL_CHART_TYPES.filter((ct) => ct.id !== "funnel-steps");
    }
    return FUNNEL_CHART_TYPES;
  }
  if (reportType === "retention") {
    return RETENTION_CHART_TYPES;
  }
  if (reportType === "flow") {
    return FLOW_CHART_TYPES;
  }
  return INSIGHT_CHART_TYPES;
}
